import { Link, useLocation } from "react-router-dom";
import { eng, tr } from "../util/languageData";
import Seo from "./Seo";
import styles from "./kvkkPage.module.css";

/**
 * KVKK aydınlatma metni / privacy notice. Linked from the contact form and
 * doubles as the data-handling one-pager for prospects. Crawlable like every
 * public page: prerendered (package.json reactSnap.include), listed in
 * public/sitemap.xml and given a full head (canonical, hreflang, description)
 * via Seo. Nothing may say noindex (see src/seo/noNoindex.test.ts).
 *
 * The language comes from the URL (/kvkk/ Turkish, /en/kvkk/ English), not
 * from the stored app language, so the prerendered HTML, the hydrated page and
 * the hreflang/canonical always agree.
 */
function KvkkPage(): JSX.Element {
  const location = useLocation();
  const isEnglish =
    location.pathname === "/en" || location.pathname.startsWith("/en/");
  const prefix = isEnglish ? "/en" : "";
  const kvkk = (isEnglish ? eng : tr).kvkk;

  return (
    <div className={styles.page}>
      <Seo
        path="/kvkk"
        title={kvkk.metaTitle}
        description={kvkk.metaDescription}
      />
      <div className={styles.container}>
        <h1 className={styles.title}>{kvkk.title}</h1>
        <p className={styles.updated}>{kvkk.updated}</p>
        <p className={styles.intro}>{kvkk.intro}</p>

        {kvkk.sections.map((section, index) => (
          <section key={index} className={styles.section}>
            <h2 className={styles.heading}>{section.heading}</h2>
            <p className={styles.text}>{section.text}</p>
          </section>
        ))}

        <Link className={styles.back} to={`${prefix}/`}>
          {kvkk.backHome}
        </Link>
      </div>
    </div>
  );
}

export default KvkkPage;
